'use client'

import { useEffect, useState } from 'react'
import { useTheme } from '@/contexts/ThemeContext'

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)
  const [isCapacitor, setIsCapacitor] = useState(false)
  const { currentTheme } = useTheme()

  useEffect(() => {
    // Check if running in Capacitor
    setIsCapacitor(typeof window !== 'undefined' && 'Capacitor' in window)
    
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  // Hide in Capacitor apps
  if (isCapacitor || !isVisible) {
    return null
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <button
      className="fixed bottom-4 right-4 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
      style={{
        background: `linear-gradient(135deg, ${currentTheme.colors.primary}, ${currentTheme.colors.primaryDark})`
      }}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  )
}
